import React from 'react';

export default () => {
  return (
    <div className="spinner-container" style={{ height: '100%', paddingTop: '100px' }}>
      <div className="spinner">
        <div className="cube1" />
        <div className="cube2" />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Loading.js